import React, { FC, useMemo, useRef, useState, useEffect } from 'react';

import { Switch } from '@chakra-ui/react';
import { Center, Flex, Text } from '@chakra-ui/layout';

import { useQuery } from 'react-query';
import { fetchAllPaginatedSKU } from 'api/sku';

import {
  EditSkuModal,
  EditSkuModalRef,
} from 'components/modules/EditSkuModall';
import { DataTable } from 'components/modules/DataTable';

import { SkuViewProps } from './Sku.props';
import { buildSkuItemsColumns } from './skuItemsColumns';

export const ItemsTable: FC<SkuViewProps> = (props) => {
  const [page, setPage] = useState<number>(1);

  const { active, setActive, search, manufacturer } = props;

  const editSkuModalRef = useRef<EditSkuModalRef>(null);

  const columns = useMemo(() => buildSkuItemsColumns(), []);

  const queryKey = [`fetch-all-sku-item`, page, active, search, manufacturer];

  const queryFn = () =>
    fetchAllPaginatedSKU('item', {
      page,
      limit: 10,
      activeOnly: active,
      search: search || undefined,
      ...(manufacturer ? { manufacturer } : {}),
    });

  const options = {
    keepPreviousData: true,
  };

  const { data, isFetching, isLoading } = useQuery(queryKey, queryFn, options);

  useEffect(() => {
    setPage(1);
  }, [search, manufacturer]);

  const items = data?.items || [];
  const totalCount = data?.total || 0;
  const totalPages = data?.totalPages || 0;

  const pagination = {
    page,
    setPage,
    totalCount,
    totalPages,
  };

  return (
    <>
      <Flex my="10px" align="center" gap="10px">
        <Text>Show Active items only</Text>
        <Switch
          colorScheme="primary"
          isChecked={active}
          onChange={(e) => setActive(e.target.checked)}
        />
      </Flex>

      <DataTable
        minW="650px"
        data={items}
        columns={columns}
        isLoading={isLoading || isFetching}
        pagination={pagination}
        onRowClick={(sku) => {
          editSkuModalRef?.current?.onOpen?.(sku);
        }}
        renderEmpty={() => (
          <Center p={8}>
            <Text fontSize="20px">No Items available</Text>
          </Center>
        )}
      />
      <EditSkuModal ref={editSkuModalRef} type={'item'} />
    </>
  );
};
